import { render, staticRenderFns } from "./UserListSideMenu.vue?vue&type=template&id=2cf7a78e"
import script from "./UserListSideMenu.vue?vue&type=script&lang=js"
export * from "./UserListSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cf7a78e')) {
      api.createRecord('2cf7a78e', component.options)
    } else {
      api.reload('2cf7a78e', component.options)
    }
    module.hot.accept("./UserListSideMenu.vue?vue&type=template&id=2cf7a78e", function () {
      api.rerender('2cf7a78e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/UserListSideMenu.vue"
export default component.exports